import { useContext } from 'react';

import { HistogramYScales } from '../contexts/HistogramYScales.context.js';
import { YScale } from '../types/histogram.js';

export const useHistogramYScales: () => YScale[] = () =>
  useContext(HistogramYScales);
